var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#DCDEE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.0195 22.9883L28.9648 24.082L24.5898 19.707L24.5898 30.9766L23.0469 30.9766L23.0469 19.707L18.6719 24.082L17.5977 22.9883L23.8086 16.7773L30.0195 22.9883Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTop);
export default __webpack_public_path__ + "static/media/btn_top.6706db3ca1296ce4d3976a86d66b9a7b.svg";
export { ForwardRef as ReactComponent };